import React from 'react';
import withIcon from '../utilities/withIcon';

const IconMinus = () => {
  return (
    <g>
      <path d="m15.2012 7.25h-14.4024a.75.75 0 0 0 0 1.5h14.4024a.75.75 0 0 0 0-1.5z" />
    </g>
  );
};

export default withIcon(IconMinus);
